












































import { defineComponent, reactive, watch } from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';

const CommonDateTimeInput = defineComponent({
  props: {
    label: { default: 'เวลา' },
    value: { type: String, default: () => '2021-03-04 00:00:00' },
    second: { default: () => true },
    level: { default: undefined },
  },
  setup(props, { emit }) {
    const HOURS = [
      '00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
      '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
      '20', '21', '22', '23',
    ];
    const MINUTES = [
      '00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
      '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
      '20', '21', '22', '23', '24', '25', '26', '27', '28', '29',
      '30', '31', '32', '33', '34', '35', '36', '37', '38', '39',
      '40', '41', '42', '43', '44', '45', '46', '47', '48', '49',
      '50', '51', '52', '53', '54', '55', '56', '57', '58', '59',
    ];
    const dateTime = reactive({
      date: (props.value && props.value !== '') ? useFormat.date(props.value).computerShortDate() : '',
      hour: (props.value && props.value !== '') ? useFormat.date(props.value).dayjs.format('HH') : '',
      minute: (props.value && props.value !== '') ? useFormat.date(props.value).dayjs.format('mm') : '',
      second: (props.value && props.value !== '') ? useFormat.date(props.value).dayjs.format('ss') : '',
    });
    const setTime = (hour: any, minute: any = -1, second: any = -1) => {
      if (hour !== -1) dateTime.hour = hour;
      else if (minute !== -1) dateTime.minute = minute;
      else dateTime.second = second;
      if (props.second) emit('input', `${dateTime.date} ${dateTime.hour}:${dateTime.minute}:${dateTime.second}`);
      else emit('input', `${dateTime.date} ${dateTime.hour}:${dateTime.minute}`);
    };
    const setDate = (date: string) => {
      if (props.second) emit('input', `${date} ${dateTime.hour}:${dateTime.minute}:${dateTime.second}`);
      else emit('input', `${date} ${dateTime.hour}:${dateTime.minute}`);
    };

    watch(() => props.value, (newVal: string, oldVal: string) => {
      if (newVal !== oldVal && newVal) {
        dateTime.date = useFormat.date(newVal).computerShortDate();
        dateTime.hour = useFormat.date(newVal).dayjs.format('HH');
        dateTime.minute = useFormat.date(newVal).dayjs.format('mm');
        dateTime.second = useFormat.date(newVal).dayjs.format('ss');
      } else {
        dateTime.date = '';
        dateTime.hour = '';
        dateTime.minute = '';
        dateTime.second = '';
      }
    });

    return {
      HOURS,
      MINUTES,
      dateTime,
      setTime,
      setDate,
    };
  },
});

export default CommonDateTimeInput;
